import PropTypes from "prop-types";
import { css } from "glamor";
import { Button } from "antd";

import sharedStyles from "./sharedStyles";

const styles = {
    alert: css({
        borderColor: "#d0021b",
        backgroundColor: "white",
    }),
};

const Alert = ({ children, size, ...otherProps }) => {
    const appliedSize = size
        ? sharedStyles.size[size]
        : sharedStyles.size.default;

    return (
        <Button
            type="danger"
            {...appliedSize}
            {...styles.alert}
            {...otherProps}
        >
            {children}
        </Button>
    );
};

Alert.propTypes = {
    children: PropTypes.string.isRequired,
};

export default Alert;
